module.exports = __webpack_public_path__ + "static/media/BasierCircle-SemiBold.f0909113.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-SemiBold.ttf
// module id = 517
// module chunks = 1